import { useRef, memo, useCallback, useEffect } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { Icon } from '~/components/common/Icon';

type PlayAudioButtonProps = {
  value: string;
  uploadAudio?: string | any;
  disabled?: boolean;
};

const PlayAudioButton = memo(
  ({ value, uploadAudio, disabled = false }: PlayAudioButtonProps) => {
    const audioRef = useRef<any>(null);

    const handleButtonClick = useCallback(() => {
      if (audioRef.current) {
        audioRef.current.play();
      }
    }, []);

    useEffect(() => {
      if (audioRef.current || uploadAudio) {
        audioRef.current.load();
      }
    }, [value, uploadAudio]);

    return (
      <Stack
        sx={{
          button: {
            backgroundColor: 'transparent !important',
            color: '#33363D !important',
          },
        }}
      >
        <audio ref={audioRef} src={value !== 'custom' ? value : uploadAudio}>
          <track kind='captions' />
        </audio>
        <Button
          variant='text'
          onClick={handleButtonClick}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '4px',
          }}
          disabled={disabled}
        >
          <Icon name='volume-up-line' color='#33363D' size={16} />
          <Typography fontWeight={600} color='#33363D'>
            Test
          </Typography>
        </Button>
      </Stack>
    );
  },
);

export default PlayAudioButton;
